(function() {
  // Klaviyo popup trigger for Rewards page subscription button
  document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname === '/pages/rewards') {
      var subBtn = Array.from(document.querySelectorAll('a.btn')).find(function(el) {
        return el.textContent.trim().toLowerCase() === 'subscription';
      });
      if (subBtn) {
        subBtn.href = '#';
        subBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (window.klaviyo) {
            window.klaviyo.openForm('QREARv');
          }
        });
      }
    }
  });
})();